export default abstract class BaseStore {
  abstract id: string;
}
